<ng-container *ngIf="!($submitted | async)">
  <h2>Share your feedback with us</h2>
  <p>Report a bug, or just tell us what you'd like to see in Socialyze.</p>

  <form [formGroup]="feedbackForm">

    <div class="fw-row mt-5">

      <label class="form-label fw-bolder text-dark fs-6">What type of feedback is it?</label>

      <nz-select
        class="w-100"
        nzShowSearch
        nzAllowClear
        nzSize="large"
        formControlName="type"
        [nzPlaceHolder]="'Select One'">
        <nz-option nzLabel="Bug Report" nzValue="Bug Report"></nz-option>
        <nz-option nzLabel="Feature Request" nzValue="Feature Request"></nz-option>
        <nz-option nzLabel="General Feedback" nzValue="General Feedback"></nz-option>
      </nz-select>

    </div>

    <div class="fw-row mt-5">

      <label class="form-label fw-bolder text-dark fs-6">Please tell us your feedback</label>

      <textarea formControlName="feedback" class="form-control form-control-solid" cols="30" rows="10"></textarea>

    </div>

  </form>

</ng-container>

<ng-container *ngIf="($submitted | async)">

  <h1>Thank you</h1>
  <p>Your feedback is really important to us, in the event you have reported a bug, our engineering team will review and respond as soon as possible.</p>

</ng-container>

<div *nzModalFooter>
  <button *ngIf="!($submitted | async)" class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button *ngIf="($submitted | async)" class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Close</button>
  <button
    *ngIf="!($submitted | async)"
    type="button"
    (click)="submitFeedback()"
    id="qrpay_sign_up_submit"
    [disabled]="
        feedbackForm.invalid || ($submitting | async)
      "
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="($submitting | async) === false">
      <span class="indicator-label">Save</span>
    </ng-container>
    <ng-container *ngIf="$submitting | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>

